import { UserManager } from 'oidc-client';
import { authConfig } from '../constants';
import { clearLS } from '../utils';
// const userManager = new UserManager(authConfig);
// ĐẢM BẢO SINGLETON (kể cả HMR)
const globalAny = window;
export const userManager = globalAny.__oidc_um__ || (globalAny.__oidc_um__ = new UserManager(authConfig));
export function signinRedirect(pathname) {
    userManager.clearStaleState();
    return userManager.signinRedirect(pathname && { state: { pathname } });
}
export function signinRedirectCallback() {
    return userManager.signinRedirectCallback();
}
export function renewToken() {
    return userManager.signinSilent();
}
export async function signoutRedirect() {
    // const user: User = getProfileFromLS();
    clearLS();
    const user = await userManager.getUser();
    await userManager.clearStaleState();
    await userManager.removeUser();
    return userManager.signoutRedirect({ id_token_hint: user?.id_token });
}
export function signoutRedirectCallback() {
    // userManager.clearStaleState();
    // userManager.removeUser();
    // clearLS();
    return userManager.signoutRedirectCallback();
}
export function getUser() {
    return userManager.getUser();
}
export async function getToken() {
    const user = await getUser();
    return user?.access_token ?? '';
}
